<template>
  <div class="statistics-group-table">
    <div
      v-if="active"
      class="statistics-group-table__groupby-select"
    >
      <span>Группировать</span>
      <cm-select
        v-model="groupby"
        :options="groupbyConfig"
      />
    </div>

    <CmStatTable
      :isLoading="isLoading"
      :isError="isError"
      :value="value"
      :cols="cols"
      :isLongTable="isLongTable"
      @open-long-table="setLongTablePart(longTableId)"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import long_table_mixin from "@/components/statistics/stats/tabs/long_table_mixin";
import CmStatTable from "@/components/library/statistics/elements/CmStatTable.vue";
import CmSelect from '@/components/library/Form/CmSelect.vue';

export default {
  name: "GroupTable",

  components: {
    CmSelect,
    CmStatTable,
  },

  mixins: [long_table_mixin],

  props: {
    longTableId: {
      type: String,
    },
    cols: {
      type: Object,
    },
    formData: {
      type: Function,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters({
      groupbyConfig: "groupbyConfig",
      groupByDetails: "getDetails",
    }),

    ...mapState({
      isLoading: state => state.stat.loadings.details,
      isError: state => state.stat.errors.details,
    }),

    groupby: {
      get() {
        return this.groupbyConfig.find(i => i.id === this.$store.state.stat.groupby);
      },
      set(next) {
        this.$store.commit("setStatGroupby", next.id);
      },
    },

    value() {
      return this.formData(this.groupByDetails, this.groupby);
    },
  },
};
</script>

<style lang="scss">
.statistics-group-table {
  &__groupby-select {
    display: flex;
    align-items: center;
    line-height: 100%;
    justify-content: flex-end;
    margin-bottom: 20px;
    .cm-select {
      margin-left: 15px;
    }
  }
  // .cm-stat-table-container {
  //   min-height: 310px;
  // }
}
</style>
